import Button from "components/base/Button";
import { BsPencilSquare } from "react-icons/bs";
import { Link } from "react-router-dom";

const PlanPageNavigationTitleView = ({ plan, editPlanName }) => {
  return (
    <div className="flex items-baseline space-x-2">
      {plan.parent ? (
        <div>
          <Link
            className="font-semibold"
            to={`/order-scheduler/plans/${plan.parent.id}`}
          >
            {plan.parent.name}
          </Link>{" "}
          / {plan.name}
        </div>
      ) : (
        <span>{plan.name}</span>
      )}
      <Button className="text-sm" onClick={editPlanName}>
        <BsPencilSquare />
      </Button>
    </div>
  );
};

export default PlanPageNavigationTitleView;
